export function logOnboardingGaEvent(logData, store) {
  try {
    logData.plan_id = store?.state?.business?.planId
    logData.industry = store?.state?.business?.industryServed
    logData.customer_count = store?.state?.business?.customerCount
    logData.have_website = store?.state?.business?.haveWebsite ? 'yes' : 'no'
    logData.website = store?.state?.business?.haveWebsite
    logData.affiliate_signup = store?.state?.business?.affiliateSignup
      ? 'yes'
      : 'no'
    logData.primary_use = store?.state?.business?.agencyPrimaryUse

    if (+logData?.onboarding_step >= 2) {
      logData.reselling = store?.state?.business?.isReselling ? 'yes' : 'no'
      logData.country = store?.state?.business?.country
      logData.state = store?.state?.business?.region
    }

    if (+logData?.onboarding_step >= 3) {
      logData.tools = store?.state?.business?.tools
        ? store?.state?.business?.tools.join(', ')
        : ''
    }

    window['dataLayer'] = window['dataLayer'] || []
    window['dataLayer'].push(logData)
  } catch (error) {
    console.log(error)
  }
}
